import axios from 'axios'
import { platformEnv } from '@/platform/config/env'
import { readRefreshToken, saveSession, type SessionTokens } from './tokens'
import { SessionExpiredError } from './sessionEvents'
import { requireSessionTokens } from './validation'

export function createSessionRefresher(dependencies: {
  read: () => string | null
  request: (token: string) => Promise<SessionTokens>
  save: (tokens: SessionTokens) => void
}) {
  let pending: Promise<string> | null = null
  return () => {
    pending ??= Promise.resolve().then(async () => {
      const token = dependencies.read()
      if (!token) throw new SessionExpiredError()
      const tokens = await dependencies.request(token)
      dependencies.save(tokens)
      return tokens.access_token
    }).finally(() => { pending = null })
    return pending
  }
}

export const refreshSession = createSessionRefresher({
  read: readRefreshToken,
  save: saveSession,
  request: async (token) => {
    try {
      const response = await axios.post(`${platformEnv.ssoApiUrl}/v1/auth/refresh`, { refresh_token: token }, { timeout: 10_000 })
      return requireSessionTokens(response.data)
    } catch (error) {
      if (axios.isAxiosError(error) && [400, 401, 403].includes(error.response?.status ?? 0)) throw new SessionExpiredError()
      throw error
    }
  },
})
